import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="fact-circle"
export default class extends Controller {
  connect() {
    this.element.addEventListener('mouseover', () => {
        this.element.classList.add('looping')
    });

    this.element.addEventListener('mouseout', () => {
        this.element.classList.remove('looping')
    });
  }
}